import { createUseStyles } from 'react-jss';

import { IconProps } from '../ShareButton/types';

const useStyles = createUseStyles<string, { backgroundColor: string; icon: IconProps }>(
  {
    root: {
      display: 'block',
      margin: 'auto',
      width: 56,
      height: 56,
      border: ({ icon }) => (icon.borderWidth ? `${icon.borderWidth}px solid #CBCBCB` : 'none'),
      borderRadius: '50%',
      backgroundColor: ({ backgroundColor }) => backgroundColor,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    icon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      fill: ({ icon }) => icon.color,
      width: ({ icon }) => icon.width || 24,
      height: ({ icon }) => icon.height || 24,
    },
  },
  {
    name: 'share-method-button',
  },
);

export default useStyles;
